import React from "react";
import { W8Ben } from "./Components/W8Ben";
import Spinner from "./Components/Spinner";
import * as background from "./public/images/background.jpg";
import {
  setPublicClientBase,
  getPublicClientBase,
  validateSignedUrl,
  getToken,
} from "./utilityFunctions";

export interface IAppState {
  loading: boolean;
  message: string;
}

export interface IW8BenUrl {
  url: string;
}

class App extends React.Component<any, IAppState> {
  constructor(props: IAppState) {
    super(props);
    this.state = {
      loading: true,
      message: "Verifying URL",
    };
  }

  componentDidMount() {
    fetch("./appsettings.json")
      .then((response) => {
        return response.json();
      })
      .then((r) => {
        var url = `https://publicclientservice.${r.APIBase}/api/v1`;
        setPublicClientBase(url);
      });

    this.validateUrl();
  }

  updateUrl = (token: string) => {
    let url = new URL(window.location.href);
    let queryParams = new URLSearchParams();
    queryParams.append("token", token);
    queryParams.append("url", url.toString());
    url.search = queryParams.toString();
    window.location.search = queryParams.toString();
  };

  validateUrl = () => {
    const token = getToken();

    if (token) {
      return;
    }

    const url = window.location.href;

    validateSignedUrl(url).then((response) => {
      if (response.status !== 200) {
        this.setState({ loading: false });
      }

      if ("Data" in response.body) {
        const token = response.body.Data.Token;
        this.updateUrl(token);
        this.setState({
          loading: false,
          message: "Success! Redirecting.",
        });
      } else {
        this.setState({
          loading: false,
          message: `An error occured. ${response.body.Message}`,
        });
      }
    });
  };

  renderForm = () => {
    return (
      <div className="embed-container">
        <W8Ben spinnerTimeOut={10000} endpoint={getPublicClientBase()!} />
      </div>
    );
  };

  renderIcon = () => {
    let style = {
      width: "100px",
      height: "65px",
    };
    return (
      <svg
        style={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 39.515 53"
      >
        <g
          id="Application_Icon"
          data-name="Application Icon"
          transform="translate(971.732 -432.94)"
        >
          <path
            id="Path_236"
            data-name="Path 236"
            d="M-948.038,484.11H-965.18a6.559,6.559,0,0,1-6.552-6.552V439.491a6.559,6.559,0,0,1,6.552-6.551h26a6.559,6.559,0,0,1,6.552,6.551v31.021a1.6,1.6,0,0,1-1.6,1.6,1.6,1.6,0,0,1-1.6-1.6V439.491a3.359,3.359,0,0,0-3.355-3.355h-26a3.359,3.359,0,0,0-3.355,3.355v38.067a3.359,3.359,0,0,0,3.355,3.355h17.143a1.6,1.6,0,0,1,1.6,1.6A1.6,1.6,0,0,1-948.038,484.11Z"
            transform="translate(0 0)"
          />
          <path
            id="Path_237"
            data-name="Path 237"
            d="M-939.4,456.7H-955.54a1.6,1.6,0,0,1-1.6-1.6,1.6,1.6,0,0,1,1.6-1.6H-939.4a1.6,1.6,0,0,1,1.6,1.6A1.6,1.6,0,0,1-939.4,456.7Z"
            transform="translate(-8.763 -12.344)"
          />
          <path
            id="Path_238"
            data-name="Path 238"
            d="M-931.861,476.7H-955.54a1.6,1.6,0,0,1-1.6-1.6,1.6,1.6,0,0,1,1.6-1.6h23.678a1.6,1.6,0,0,1,1.6,1.6A1.6,1.6,0,0,1-931.861,476.7Z"
            transform="translate(-8.763 -24.352)"
          />
          <path
            id="Path_239"
            data-name="Path 239"
            d="M-935.628,489.7H-955.54a1.6,1.6,0,0,1-1.6-1.6,1.6,1.6,0,0,1,1.6-1.6h19.911a1.6,1.6,0,0,1,1.6,1.6A1.6,1.6,0,0,1-935.628,489.7Z"
            transform="translate(-8.763 -32.158)"
          />
          <path
            id="Path_240"
            data-name="Path 240"
            d="M-931.861,502.7H-955.54a1.6,1.6,0,0,1-1.6-1.6,1.6,1.6,0,0,1,1.6-1.6h23.678a1.6,1.6,0,0,1,1.6,1.6A1.6,1.6,0,0,1-931.861,502.7Z"
            transform="translate(-8.763 -39.963)"
          />
          <path
            id="Path_241"
            data-name="Path 241"
            d="M-946.928,520.7h-8.611a1.6,1.6,0,0,1-1.6-1.6,1.6,1.6,0,0,1,1.6-1.6h8.611a1.6,1.6,0,0,1,1.6,1.6A1.6,1.6,0,0,1-946.928,520.7Z"
            transform="translate(-8.763 -50.771)"
          />
          <path
            id="Path_242"
            data-name="Path 242"
            d="M-898.178,530.058-914.92,523.5l6.559,16.742,2.773-4.716,4.788,4.789,2.694-2.694-4.789-4.789Z"
            transform="translate(-34.111 -54.373)"
          />
        </g>
      </svg>
    );
  };

  render() {
    let token = getToken();
    return (
      <div
        style={{
          height: token ? "auto" : "100vh",
          backgroundImage: !token ? `url(${background})` : "",
        }}
        className="App"
      >
        {token ? (
          this.renderForm()
        ) : (
          <div className="form">
            <div className="grid">
              <div
                className="grid__col grid__col--2-of-2"
                style={{ textAlign: "center", marginBottom: "20px" }}
              >
                <div>{this.renderIcon()}</div>
                <h1>
                  <strong>W-8BEN Online Form</strong>
                </h1>
                <h2>{this.state.message}</h2>
              </div>
              <br />
              {this.state.loading && <Spinner />}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default App;
